export default "__VITE_ASSET__qVlQ3jsh__"